import { 
    EXPERIENCES,
    SEARCHED,
    TOTAL
 } from "../types";



export const experiences = data => {
    return {
        type: EXPERIENCES,
        data,
    }
}

export const searched = data => {
    return {
        type: SEARCHED,
        data,
    }
}

export const total = data => {
    return {
        type: TOTAL,
        data,
    }
}
